import React from 'react';

import {TThemeEditorContext} from '../types';

export default React.createContext<TThemeEditorContext | undefined>(undefined);
